import { InjectionToken } from '@angular/core';
import { ROUTE_OVERRIDE } from '@df/core/meta/meta-state';
import { Nexus } from '@tomandco/nexus-api-types';

export namespace NSession {
    export const DEFAULT_OPTIONS: IModuleOptions = {
        wishlist: {
            guest: false,
            loadProducts: false,
            productVerbosity: 2
        },
        notRespectMustLoginRoutes: [new RegExp(`^/${ROUTE_OVERRIDE['login'] || 'login'}(/.*)?$`)],
        onCustomerLoggedGuardErrorUrl: `/${ROUTE_OVERRIDE['login'] || 'login'}`,
        basket: {
            loadProductParent: true
        }
    };

    export const OPTIONS = new InjectionToken<IModuleOptions>('DF_SESSION_OPTIONS', {
        providedIn: 'root',
        factory: () => DEFAULT_OPTIONS
    });

    export interface IModuleOptions {
        wishlist: {
            /**
             * If guest wishlist is allowed
             */
            guest: boolean;
            /**
             * If wishlist products should be loaded
             */
            loadProducts: boolean;
            /**
             * Product werbosity
             */
            productVerbosity: number;
        };
        /**
         * routes which customer can access even if login is required
         */
        notRespectMustLoginRoutes: RegExp[];
        /**
         * Redirect url when customer is not logged on guarded route
         */
        onCustomerLoggedGuardErrorUrl: string;
        /**
         * Basket options
         */
        basket: {
            /**
             * If parent product should be loaded for basket items
             */
            loadProductParent: boolean;
        };
    }
}

declare module '@df/core/service/df-event' {
    interface IEventType {
        /**
         * Trigger it when viewing cart / minicart
         */
        dfBasketView: DfEventConfig<
            'dfBasketView',
            {
                context: 'basket' | 'minibasket';
            },
            void
        >;
        /**
         * Trigger when beggining checkout
         */
        dfCheckoutBegin: DfEventConfig<'dfCheckoutBegin', {}, void>;
        /**
         * Trigger when beggining checkout
         */
        dfCheckoutChange: DfEventConfig<
            'dfCheckoutChange',
            {
                type: 'paymentMethod' | 'shippingMethod' | 'address';
                quote: Nexus.Api.Checkout.Load.Response['checkout'];
            },
            void
        >;
    }
}
